/**
 * fs-header-breakpoint.js
 *
 * Drives data-menu-style by viewport width (990px threshold) instead of
 * isTouchDevice(). This makes hamburger/nav switch instant on resize — no
 * page reload needed.
 *
 * MutationObserver corrects any JS changes made by utilities.js / header-menu.js.
 * Overflow-list minimum-reached behaviour is preserved: if nav links overflow
 * at desktop width, drawer mode still activates correctly.
 */

const headerComponent = document.querySelector('#header-component');

if (headerComponent) {
  const mql = window.matchMedia('(min-width: 990px)');

  function applyMenuStyle() {
    const overflowList = headerComponent.querySelector('overflow-list');
    const hasReachedMinimum = overflowList?.hasAttribute('minimum-reached');
    const correct = mql.matches && !hasReachedMinimum ? 'menu' : 'drawer';
    if (headerComponent.dataset.menuStyle !== correct) {
      headerComponent.dataset.menuStyle = correct;
    }
  }

  // Instant response when viewport crosses the 990px threshold
  mql.addEventListener('change', applyMenuStyle);

  // Intercept and correct any isTouchDevice()-driven changes from theme JS
  new MutationObserver(applyMenuStyle).observe(headerComponent, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
  });

  // Apply correct value immediately (runs after theme.liquid's inline script)
  applyMenuStyle();
}
